import { useSyncExternalStore } from "react";

/**
 * Almacén de actividad de Nova: un registro cronológico de lo que hace (consultas, propuestas,
 * escrituras, adjuntos, errores). Es un store externo mínimo —sin dependencias— para que tanto el
 * chat (fuentes/pasos) como el log estilo terminal del Panel lean de la MISMA fuente sin prop
 * drilling. Vive fuera de React: sobrevive a que el chat se monte/desmonte al navegar.
 */

export type NivelActividad = "info" | "exito" | "aviso" | "error";

export interface EventoActividad {
  id: number;
  ts: number;
  nivel: NivelActividad;
  /** Texto corto de la línea (una acción). */
  texto: string;
  /** Detalle opcional (p. ej. el nombre de la herramienta o del recurso). */
  detalle?: string;
}

const LIMITE = 300;
let eventos: EventoActividad[] = [];
let contador = 0;
const suscriptores = new Set<() => void>();

function emitir() {
  for (const s of suscriptores) {
    s();
  }
}

/** Registra un evento de actividad de Nova. Devuelve el evento creado. */
export function registrarActividad(
  nivel: NivelActividad,
  texto: string,
  detalle?: string,
): EventoActividad {
  const evento: EventoActividad = {
    id: ++contador,
    ts: Date.now(),
    nivel,
    texto,
    ...(detalle !== undefined ? { detalle } : {}),
  };
  // Copia nueva (inmutable) para que useSyncExternalStore detecte el cambio; recorta el historial.
  eventos = [...eventos, evento].slice(-LIMITE);
  emitir();
  return evento;
}

/** Vacía el registro (botón "limpiar" del log). */
export function limpiarActividad() {
  eventos = [];
  emitir();
}

function subscribe(cb: () => void): () => void {
  suscriptores.add(cb);
  return () => suscriptores.delete(cb);
}

function getSnapshot(): EventoActividad[] {
  return eventos;
}

/** Hook: la lista de eventos, reactiva. */
export function useActividad(): EventoActividad[] {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
